module.exports = __webpack_public_path__ + "img/cancel@3x.f30649e1.png";